import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SubTitleBox = styled.div`
  display: flex;
  flex: 1 1 auto;
`;

export const SubTitle = styled.h3`
  ${({ theme }) => css`
    display: block;
    ${theme.fontStyle.text.body16_medium}
    ${theme.content.hierarchy3}
  `}
`;

export const ButtonBox = styled.div`
  display: flex;
  position: fixed;
  z-index: 5;
  bottom: 16px;
  left: 50%;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
  transform: translateX(-50%);
  gap: 16px;
`;

export const SendMailButtonBox = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const SendMailButton = styled.button`
  ${({ theme }) => css`
    display: block;
    padding: 8px;
    ${theme.fontStyle.label.button16_medium}
    color: ${theme.content.hierarchy3};
    text-align: center;
    text-decoration: underline;
    text-underline-position: under;
  `}
`;
